// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '../core/button';

// Styles
import './bulk-mapping-buttons.scss';

function BulkMappingButtons({bulkMapping, cancelMapping, fetched, handleCompleteMapping, shouldDisableCompleteButton}) {
    const shouldRenderButton = (type) => {
        const conditional = {
            cancelMapping: () => bulkMapping && !fetched,
            completeMapping: () => bulkMapping && !fetched,
        };

        return conditional[type] ? conditional[type]() : false;
    };

    const renderButton = (type) => {
        const renderButtonProps = {
            cancelMapping: {
                children: 'Exit Bulk Mapping',
                onClick: cancelMapping,
            },
            completeMapping: {
                children: 'Complete Bulk Mapping',
                disabled: shouldDisableCompleteButton,
                onClick: handleCompleteMapping,
            },
        };

        return shouldRenderButton(type) ? (
            <Button {...renderButtonProps[type]} className="bulk-mapping-buttons--button" />
        ) : null;
    };

    return (
        <div className="bulk-mapping-buttons--actions">
            {renderButton('completeMapping')}
            {renderButton('cancelMapping')}
        </div>
    );
}

BulkMappingButtons.propTypes = {
    bulkMapping: PropTypes.bool,
    cancelMapping: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    handleCompleteMapping: PropTypes.func.isRequired,
    shouldDisableCompleteButton: PropTypes.bool,
};

export default BulkMappingButtons;
